import { QUERY_KEYS } from "@/common/query-keys";
import { checkinConsumable } from "@/lib/snipeit/consumables";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useLocation } from "wouter";

export function useCheckinConsumable() {
  const queryClient = useQueryClient();
  const [, navigate] = useLocation();

  return useMutation({
    mutationFn: ({ consumableId, newQty }: { consumableId: number; newQty: number }) =>
      checkinConsumable(consumableId, newQty),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.consumablesPage] });
      navigate("/consumables");
    },
  });
}
